// **NOTE** labelText/text values are keys of dictionary items
export const dropdownsData = [
  {
    labelText: 'contactForm.iAm',
    value: 'a brand',
    name: 'iam',
    options: [
      {
        value: 'a brand',
        text: 'contactForm.aBrand',
      },
      {
        value: 'an agency',
        text: 'contactForm.anAgency',
      },
      {
        value: 'a creator',
        text: 'contactForm.aCreator',
      },
      {
        value: 'an educational institution',
        text: 'contactForm.anEducationalInstitution',
      },
      {
        value: 'a spotify user',
        text: 'contactForm.aSpotifyUser',
      },
      {
        value: 'other',
        text: 'contactForm.other',
      },
    ],
  },
  {
    labelText: 'contactForm.lookingTo',
    value: 'drive revenue',
    name: 'looking-to',
    options: [
      {
        value: 'drive revenue',
        text: 'contactForm.driveRevenue',
      },
      {
        value: 'grow awareness',
        text: 'contactForm.growAwareness',
      },
      {
        value: 'drive traffic',
        text: 'contactForm.driveTraffic',
      },
      {
        value: 'promote music',
        text: 'contactForm.promoteMusic',
      },
      {
        value: 'get help',
        text: 'contactForm.getHelp',
      },
      {
        value: 'other',
        text: 'contactForm.other',
      },
    ],
  },
];
